<template>
  <div>
    <banner-top :text="titletext"></banner-top>
    <div class="bg"></div>
    <div class="order">
        <div>订单号</div>
        <div>{{order}}</div>
    </div>
    <div class="order">
        <div>订单金额</div>
        <div style="color:#ff0000!important;">￥{{detail}}</div>
    </div>
    <div class="order">
        <div>支付剩余时间</div>
        <div style="color:#ff0000!important;">{{setTime}}</div>
    </div>
    <div class="payfunc">支付方式</div>
    <!-- <div class="order" @click="checked = true">
        <div>
            <img class="picture" src="../assets/icon29.png" alt="">
            <span>支付宝支付</span>
        </div>
        <div>
            <img class="check" v-if="checked" src="../assets/icon31.png" alt="">
        </div>
    </div> -->
    <div class="order" @click="checked = false">
        <div>
            <img class="picture" src="../assets/icon30.png" alt="">
            <span>微信支付</span>
        </div>
        <div>
            <img class="check" v-if="!checked" src="../assets/icon31.png" alt="">
        </div>
    </div>
    <div class="nav">
        <button v-if="payCheck" class="button1" @click="pay">支付</button>
        <button v-else class="button2">支付</button>
    </div>
  </div>
</template>

<script>
import bannerTop from '../components/BannerTop.vue'
import http from '../utils/http'
import wx from 'weixin-js-sdk'

export default {
  name: 'pay',
  components: { bannerTop },
  data () {
    return {
      appId: 'wx31204e1c418a87b7',
      checked: false,
      titletext: '选择支付方式',
      order: '',
      detail: '',
      code: '',
      setTime: '已自动取消订单',
      payCheck: true
    }
  },
  methods: {
    pay () {
      const currentUrl = encodeURIComponent(window.location.href)
      const scope = 'snsapi_base'
      window.location.href =
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appId}&redirect_uri=${currentUrl}&response_type=code&scope=${scope}#wechat_redirect`
    }
  },
  mounted () {
    this.order = this.$route.query.order_no
    this.detail = this.$route.query.detail
    let self = this
    let mytime = this.$route.query.created
    console.log(mytime)
    let dateTmp = mytime.replace(/-/g, '/')
    let timestamp = Date.parse(dateTmp)
    let newDate = new Date().getTime()
    timestamp = timestamp + 1000 * 60 * 15
    let ifdate = timestamp - newDate
    ifdate = ifdate / 1000
    if (this.$route.query.code) {
      http['get'](`mp/jsapi_config?url=${window.location.href}`).then((data) => {
        wx.config({
          // 开启调试模式，调用的所有api的返回值会在客户端alert出来
          // 若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          debug: process.env.NODE_ENV !== 'production',
          // 必填，公众号的唯一标识
          appId: data.appId,
          // 必填，生成签名的时间戳
          timestamp: data.timestamp,
          // 必填，生成签名的随机串
          nonceStr: data.nonceStr,
          // 必填，签名
          signature: data.signature,
          // 必填，需要使用的JS接口列表
          jsApiList: [
            'chooseWXPay'
          ]
        })
        wx.ready(() => {
          http['post']('pay/weixin', {
            order_no: this.order,
            code: this.$route.query.code
          }).then((res) => {
            if (res.free_order) {
              self.$router.push({name: 'succeed', query: {order_no: self.order}})
              return
            }
            wx.chooseWXPay({
              appId: res.appId,
              timestamp: res.timeStamp,
              nonceStr: res.nonceStr,
              package: res.package,
              signType: res.signType,
              paySign: res.paySign,
              // 支付成功
              success: function () {
                self.$router.push({name: 'succeed', query: {order_no: self.order}})
              },
              // 取消支付
              cancel: function () {
                self.$router.push({name: 'order'})
              },
              // 支付失败
              fail: function () {
                self.$router.push({name: 'order'})
              }
            })
          })
        })
      })
    }
    if (ifdate < 0) {
      this.setTime = '已自动取消订单'
      this.payCheck = false
    } else {
      return new Promise((resolve, reject) => {
        this.setTime = parseInt(ifdate / 60) + ':' + parseInt(ifdate % 60)
        this.myTime = setInterval(() => {
          ifdate = ifdate - 1
          this.setTime = parseInt(ifdate / 60) + ':' + parseInt(ifdate % 60)
          if (ifdate < 0) {
            clearInterval(this.myTime)
            this.myTime = null
            this.setTime = '已自动取消订单'
            this.payCheck = false
            resolve()
          }
        }, 1000)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
    position: absolute;
    width: 100%;
    height: 110%;
    top: -10%;
    background: #f5f5f5;
    z-index: -1;
}
.order {
    color: #333;
    display: flex;
    justify-content: space-between;
    padding: 0.8rem;
    background: #fff;
    border-bottom: #ccc 1px solid;
}
.payfunc {
    height: 4rem;
    text-align: center;
    line-height: 4rem;
    font-size: 18px;
    color: #666;
}
.order div span{
    color: #666;
    position: relative;
    top: -0.8rem;
}

.picture {
    margin: 0.2rem;
    width: 2rem;
}
.check {
    margin: 0.5rem;
    width: 1.6rem;
}
.navUnpay {

}
.nav {
  width: 100%;
  height: 3rem;
  display: flex;
  margin-top: 1.5rem;
  justify-content: center;
}
.nav .button1 {
    width: 80%;
    height: 2.5rem;
    background: #ffb949;
    border-radius: 44px;
    border: 0;
    color: #fff;
    font-size: 18px;
}
.nav .button2 {
    width: 80%;
    height: 2.5rem;
    background: rgb(182, 179, 179);
    border-radius: 44px;
    border: 0;
    color: #fff;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/order/pay.vue